const publicUrl = {
    http: 'https://51.51wenju.com.cn/', //线上地
    http1: 'https://51.51wenju.com/', //汪仙五本地http://192.168.1.215:8014/
    // http1:'http://192.168.1.149:81/',//汪仙五本地
    // http1: 'http://51wenju.io/',
    http2: '', //朴崇江
    http3: '', //杨森
    register: 'user/login/register', //用户注册
    login: 'user/login/login', //用户登录
    rjtestcode: 'user/rjtest/code', //人机验证
    searchlist: 'user/search/list', //网站设置
    loginfologin: 'user/loginfo/login', //微信扫码绑定
    loginfobdlogin: 'user/loginfo/bdlogin', //是否绑定过微信
    getCode: 'user/login/getCode', //获取验证码,
    logingetCodeInfo: 'user/login/getCodeInfo', //验证码人机验证登录
    editpsw: 'user/personal/editpsw', //忘记密码
    personalmessage: 'user/personal/message', //个人中心总计
    personalusermsg: 'user/personal/usermsg', //个人中心基本信息
    personalupdates: 'user/personal/updates', //个人中心基本信息修改
    personalphonelink: 'user/personal/phonelink', //绑定手机号功能
    personalgetphone: '/user/personal/getphone', //获取手机号
    personaldelphone: '/user/personal/delphone', //解绑手机号
    personalemail: 'user/personal/email', //绑定邮箱
    personaldelemail: '/user/personal/delemail', //解绑邮箱
    personalgetemail: '/user/personal/getemail', //获取邮箱
    personalemailcode: '/user/personal/emailcode', //获取邮箱验证码
    getrule: 'user/agree/getagree', // 获取注册协议内容
    addressselects: 'user/address/selects', //获取收货地址
    addressinserts: 'user/address/inserts', //添加收货地址
    addressupdates: 'user/address/updates', //修改收货地址
    addressdeletes: 'user/address/deletes', //删除收货地址
    jifenlist: 'user/jifen/list', //个人中心积分展示

    personalcaigou: 'user/personal/caigou', //获取集团账号接口
    personaladdcaigou: 'user/personal/addcaigou', //添加采购员接口
    personaldelcaigou: 'user/personal/delcaigou', //删除采购员账号
    personaleditcaigou: 'user/personal/editcaigou', //修改采购员密码额度
    personalshenpi: 'user/personal/shenpi', //采购员审批状态

    categorylist: 'goods/category/list', //商品分类
    homefloor: 'goods/home/floor', //商品楼层
    advertiselist: 'user/advertise/list', //楼层广告位
    goodsinfo: 'goods/goods/info', //商品详情
    aftersaleget: 'goods/aftersale/get', //商品售后展示

    //商品收藏
    collectcollect_info: 'user/collect/collect_info', //商品是否被收藏过
    collectcollect_goods: 'user/collect/collect_goods', //添加商品收藏
    collectcancle_goods: 'user/collect/cancle_goods', //取消商品收藏
    collectselects: 'user/collect/selects', //用户收藏的所有商品
    Userhostoryinsert: 'user/Userhostory/insert', //添加浏览历史
    Userhostoryselect: 'user/Userhostory/select', //浏览历史
    Userhostorydelete: 'user/Userhostory/delete', //删除浏览历史
    redenvelopelistsget: 'redenvelope/lists/get',//红包

    //商品品牌馆、分类
    brandlist: 'goods/brand/list', //品牌馆分类
    brandpage: 'goods/brand/page', //品牌馆内页
    goodssearch: 'goods/goods/search', //商品搜索接口
    categorypage: 'goods/category/page', //分类内页
    goodskeywords: 'goods/goods/keywords', //热门搜索关键词

    //购物车
    UsercartaddCart: 'user/Usercart/addCart', //添加购物车
    usercartdetail: 'user/usercart/detail', //购物车展示
    usercartcount: 'user/usercart/count', //购物车数量修改
    usercartdelcart: 'user/usercart/delcart', //购物车删除
    userusercartcollect: 'user/usercart/collect',//一键移入收藏夹
    //订单部分
    ordercreated: 'order/order/created', //订单创建
    deliverylists: 'order/delivery/lists', //配送方式
    jifennumber: 'user/jifen/number', //单次订单可获取积分
    orderpay: 'order/order/pay', //支付订单
    goodsnumber: 'user/goods/number', //
    orderpayStatus: 'order/order/payStatus', //订单支付情况获取
    deliverygetDistrict: 'order/delivery/getDistrict', //邮费方式获取
    usercartchanges: 'user/usercart/changes', //加入收藏夹移除收藏夹
    deliverygetDelivery: 'order/delivery/getDelivery', //根据收货地址选择配送方式
    statusCount: 'order/order/statusCount', //查询订单各个状态数量
    orderlists: 'order/order/lists', //订单列表
    ordergetOrder: 'order/order/getOrder', //订单详情
    ordercancelOrder: 'order/order/cancelOrder', //取消订单
    order_refundrefund: 'order/order_refund/refund', //申请退款
    orderfinish: 'order/order/finish', //订单确认收货
    orderstatusCount: 'order/order/statusCount', //查询订单各个状态下的数量
    orderstate: 'order/order/state', //删除已取消，已过期订单
    getOrderSku: 'order/order/getOrderSku', //获取订单单个商品详情
    order_invoicelists: 'order/order_invoice/lists',//配送单列表查询
    order_invoiceexpress: 'order/order_invoice/express',//物流信息查询
    delivery_locuslists: 'order/delivery_locus/lists',//51配送查询
    order_invoice_skulists: 'order/order_invoice_sku/lists',//配送单商品
    //活动
    promotionspanic_buyingget: 'goods/promotions/panic_buying/get', //疯狂抢购列表
    promotionspanic_buyinginfo: 'goods/promotions/panic_buying/info', //疯狂抢购详情
    commentavgcomment: 'user/comment/avgcomment', //获取商品评分
    goodsjumpToDetails: 'goods/goods/jumpToDetails', //订单商品跳转到详情
    promotionsprice_reductionget: 'goods/promotions/price_reduction/get', //限时促销
    promotionsprice_reductioninfo: 'goods/promotions/price_reduction/info', //限时促销详情
    order_goods_skurecode: 'order/order_goods_sku/recode', //购买记录
    orderexpress: 'order/order/express', //物流信息
    goodsmaylike: 'goods/goods/maylike', //猜你喜欢
    itemremen: 'user/item/remen', //热门晒单
    goodssales: 'goods/goods/sales', //销量排名
    //售后
    customerlist: 'order/order_sku_after/lists', //获取订单列表
    upcustomerimg: 'order/order_after_media/uploadFile', //上传售后图片 
    removecustomerimg: 'order/order_after_media/state', //移除售后图片 
    createdcustomer: 'order/order_sku_after/saveOrderSkuAfter', //创建售后订单
    order_goods_skustatusCount: 'order/order_goods_sku/statusCount', //获取售后的数量
    order_goods_skulists: 'order/order_goods_sku/lists', //售后列表
    order_sku_after: 'order/order_sku_after/show', //获取售后详情
    ordercancel: 'order/order_sku_after/cancel', //撤销申请
    //《--------- Vivatu-------------》
    gethelplist: 'user/article/list', //获取帮助中心文章列表
    gethelplistinner: 'user/article/detail', //获取帮助中心文章内容
    getnewall: 'user/notice/list', //获取公告与站内信
    getnewinner: 'user/notice/detail', //获取公告与站内信内容
    getmailnum: 'user/notice/number', //获取公告与站内信内容
    upimg: '/user/comment/base64imgsave', //图片上传
    Panicbuyingbanner: '/user/advertise/list', //
    idospeak: '/user/Comment/submit', //商品评论
    ipeaklook: '/user/comment/comment', //商品评论
    getspeak: '/user/Comment/search', //获取商品评论
    //积分类
    getintegral: '/user/jifen/number', //获取单个订单积分量
    purchasecreated: 'order/purchase/created', //创建采购
    purchaselists: 'order/purchase/lists', //采购审核订单列表
    purchaseshow: 'order/purchase/show', //采购订单详情
    purchasesaveStatus: 'order/purchase/saveStatus', //修改订单审核状态
    //发票类
    invoiceordersget: 'invoice/orders/get', //申请发票订单列表
    invoicetitlecheck: 'invoice/title/check',//检查用户发票抬头
    invoicetitleset: 'invoice/title/set',//设置 修改发票抬头
    invoiceordersapply: 'invoice/orders/apply',//申请开票
    invoicelistsget: 'invoice/lists/get',//获取发票列表接口
    invoicelistsorder: 'invoice/lists/order',//发票关联订单
    //场景
    goodssceneslists: 'goods/scenes/lists',//所有场景
    goodsscenesget: 'goods/scenes/get',//场景下商品
    //余额变更记录
    userbalancerecordlists: 'order/user_balance_record/lists',//余额变更记录
    orderrecharge_recordrecharge: 'order/recharge_record/recharge',//充值
    orderrecharge_recordpayStatus: 'order/recharge_record/payStatus',//充值状态查询
    useradvertisegetPositionBanner: 'user/advertise/getPositionBanner',//充值广告位
    orderuserbalancerecordgetCountMoney: 'order/user_balance_record/getCountMoney',//余额统计
    //绑定订单到用户
    orderorderrelatedUser: 'order/order/relatedUser',//绑定订单到用户
}
export default publicUrl;